import $ from "jquery";
globalThis.jQuery = $;
globalThis.$ = $;
